export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Clear-Big-Gray-01f0edabd41332e7d7b9ec3fc8356b3f.svg";